import 'core-js/es6/map';
import 'core-js/es6/set';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { createHashHistory } from 'history';
import { Provider } from 'react-redux';
import { Route } from 'react-router';
import { ConnectedRouter  } from 'react-router-redux';

import { FlashMessageActionCreators } from 'actions/flashMessage';
import { configureAnalytics, sendPageView } from 'helper/analytics';
import { configureApi } from 'helper/api';
import { configureApp } from 'helper/app';
import { configureCheckout } from 'helper/checkout';
import { configureLog } from 'helper/log';
import { Config } from 'models/config';
import { configureStore } from 'reducers/store';

import { App } from './App';

import './index.scss';

const config: Config = {
  apiUrl: process.env.REACT_APP_API_URL || '',
  appUrl: process.env.REACT_APP_URL || '',
  checkoutUrl: process.env.REACT_APP_CHECKOUT_URL || '',
  clientId: process.env.REACT_APP_CLIENT_ID || '',
  clientSecret: process.env.REACT_APP_CLIENT_SECRET || '',
  env: process.env.NODE_ENV || '',
  gaTrackingCode: process.env.REACT_APP_GA_TRACKING_CODE || '',
  sentryDsn: process.env.REACT_APP_SENTRY_DSN || '',
  timeout: 30000
};

configureAnalytics(config);
configureApi(config);
configureApp(config);
configureCheckout(config);
configureLog(config);

const history = createHashHistory();
const store = configureStore(config, history);
const version = `KASPAY_VERSION=${__VERSION__}`;
console.log(version); // tslint:disable-line

history.listen((location) => {
  sendPageView(location.pathname);
  store.dispatch(FlashMessageActionCreators.dismiss.create());
});

ReactDOM.render(
  <Provider store={store} key="provider">
    <ConnectedRouter history={history}>
      <Route path="/" component={App}/>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('kaspay-root') as HTMLElement
);

if ('serviceWorker' in navigator) {
  navigator
    .serviceWorker
    .register(process.env.PUBLIC_URL + '/service-worker.js')
    .then((reg) => {
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (reg.active && newWorker.state === 'installed') {
              window.location.reload(true);
            }
          });
        }
      });
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx